<template>
	<div class="bg-white px-3 goods_create"
		style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'khgl_khgl_khxx' }" style="position: absolute;top: 32px;left: 200px;"><el-button
				size="mini">回到客户列表</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 33%;">
					<el-form-item label="客户名">
						<div style="color: #0088ff;">{{lists.name}}</div>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="前操作人">
						<div style="color: #0088ff;">{{lists.jfpzczr == null ? '' :lists.jfpzczr.name}}</div>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="前操作时间">
						<div>{{lists.jfpz_czsj}}</div>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<div class="d-flex" style="width: 100%;">
			<div style="width: 40%;">
				<el-table :data="jfpzlist" border style="width: 100%" key="tablec" size="mini"	:header-cell-style="{ background: '#f0f1fa' }">
					<el-table-column prop="name" label="费用名称" width="130">
            <template slot-scope="scope">
                <div>
                  {{scope.row.name}}
                  <el-link title="复制当前数据到下一行" v-if="scope.row.type===7" type="primary" @click="tjjfpz(scope.$index,5)"><i class="el-icon-plus"></i></el-link>
                  <el-link title="复制当前数据到下一行" v-if="scope.row.type===3" type="primary" @click="tjjfpz(scope.$index,null)"><i class="el-icon-plus"></i></el-link>
                </div>
            </template>

          </el-table-column>
					<el-table-column prop="min" label="从(包括)" align="center">
						<template slot-scope="scope">
              <template  v-if="scope.row.unit === 5">
                <el-time-select  style="width: 100%;height: 100%;"
                                 :picker-options="{
                                      start: '00:00',
                                      step: '00:01',
                                      end: '23:59'
                                  }"
                                 v-model="scope.row.extend_params.start_time"
                                 placeholder="选择时间">
                </el-time-select>
              </template>

              <template v-else>
                <el-input-number size="mini" v-model="scope.row.min" style="width: 100%;"
                                 :min='0'></el-input-number>
              </template>

						</template>
					</el-table-column>
					<el-table-column prop="max" label="到(包括)" align="center">
						<template slot-scope="scope">
              <template  v-if="scope.row.unit === 5">
                <el-time-select  style="width: 100%;height: 100%;"
                                 :picker-options="{
                                      start: '00:00',
                                      step: '00:01',
                                      end: '23:59'
                                  }"
                                v-model="scope.row.extend_params.end_time"
                                placeholder="选择时间">
                </el-time-select>
              </template>

              <template v-else>
                <el-input-number size="mini" v-model="scope.row.max" style="width: 100%;"
                                 :min='0'></el-input-number>
              </template>

						</template>
					</el-table-column>
					<el-table-column prop="price" label="单价" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.price" style="width: 100%;" :min='0'
								:precision="2"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="unit" label="计费单位" align="center">
						<template slot-scope="scope">
							<el-select v-model="scope.row.unit" placeholder="请选择" size="mini" style="width: 100%;">
								<el-option v-for="item in option" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div style="margin-left: 2%;width: 58%">
				<el-button type="primary" style="margin-bottom: 10px;" @click="kzgg">扩展规格</el-button>
				<el-table :data="jfpzlista" border style="width:100%;" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" v-if="jfpzlista.length != 0">

					<el-table-column prop="min" label="备注名" align="center">
						<template slot-scope="scope">
							<el-input size="mini" v-model="scope.row.desc" style="width: 100%;"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="type" label="费用类型" width="130">
						<template slot-scope="scope">
							<el-select v-model="scope.row.type" placeholder="请选择" size="mini" style="width: 100%;">
								<el-option v-for="items in options" :key="items.id" :label="items.name" :value="items.id"></el-option>
							</el-select>
						</template>
					</el-table-column>

					<el-table-column prop="hw_id" label="关联货物" width="130">
						<template slot-scope="scope">
							<el-select v-model="scope.row.hw_id" filterable placeholder="请选择" size="mini" style="width: 100%;">
								<el-option v-for="itema in ckcplist" :key="itema.id" :label="itema.name" :value="itema.id"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="min" label="从(包括)" align="center">

						<template slot-scope="scope">
              <template  v-if="scope.row.unit === 5">
                <el-time-select  style="width: 100%;height: 100%;"
                                 :picker-options="{
                                      start: '00:00',
                                      step: '00:01',
                                      end: '23:59'
                                  }"
                                 v-model="scope.row.extend_params.start_time"
                                 placeholder="选择时间">
                </el-time-select>
              </template>

              <template v-else>
                <el-input-number size="mini" v-model="scope.row.min" style="width: 100%;"
                                 :min='0'></el-input-number>
              </template>
						</template>
					</el-table-column>
					<el-table-column prop="max" label="到(包括)" align="center">
						<template slot-scope="scope">
              <template  v-if="scope.row.unit === 5">
                <el-time-select  style="width: 100%;height: 100%;"
                                 :picker-options="{
                                        start: '00:00',
                                        step: '00:01',
                                        end: '23:59'
                                    }"
                                 v-model="scope.row.extend_params.end_time"
                                 placeholder="选择时间">
                </el-time-select>
              </template>
              <template v-else>
                <el-input-number size="mini" v-model="scope.row.max" style="width: 100%;"
                  :min='0'></el-input-number>
              </template>
            </template>
					</el-table-column>
					<el-table-column prop="price" label="单价" align="center">
						<template slot-scope="scope">
							<el-input-number size="mini" v-model="scope.row.price" style="width: 100%;" :min='0'
								:precision="2"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="unit" label="计费单位" align="center">
						<template slot-scope="scope">
							<el-select v-model="scope.row.unit" placeholder="请选择" size="mini" style="width: 100%;">
								<el-option v-for="item in option" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</template>
					</el-table-column>
				</el-table>
			</div>

		</div>

		<div style="height: 200px;"></div>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	export default {
		inject: ['app', 'layout'],
		data() {
			return {
				lists: {},
				jfpzlist: [],
				jfpzlista: [],
				ckcplist:[],
				option: [
					{
						id: 1,
						name: '吨'
					},
					{
						id: 2,
						name: '平方'
					},
					{
						id: 3,
						name: '板'
					},
          {
            id: 4,
            name: '件'
          },
          {
            id: 5,
            name: '时间'
          }
				],
				options: [
					{
						id: 0,
						name: '低温操作费'
					},
					{
						id: 1,
						name: '高温操作费'
					},
					{
						id: 2,
						name: '干仓操作费'
					},
					{
						id: 3,
						name: '冷藏费'
					},
					{
						id: 4,
						name: '分拣费'
					},
					{
						id: 5,
						name: '转单费'
					},
					{
						id: 6,
						name: '过车费'
					},
					{
						id: 7,
						name: '加班费'
					},
					{
						id: 8,
						name: '拉膜费'
					},
					{
						id: 9,
						name: '贴标费'
					},
					{
						id: 10,
						name: '抄码费'
					},
					{
						id: 11,
						name: '看货费'
					},
					{
						id: 12,
						name: '场地费'
					},
					{
						id: 13,
						name: '翻板费'
					},
					{
						id: 14,
						name: '打包费'
					},
					{
						id: 15,
						name: '复冻费'
					},
					{
						id: 16,
						name: '搬运费'
					},
					{
						id: 17,
						name: '过磅费'
					}
				],
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user
			})
		},
		// 生命周期
		created() {
			this.__init()
			this.axios.get('/admin/hwlist', {
					token: true
				})
				.then(res => {
					let data = res.data.data
					this.ckcplist = data
				})
		},
		methods: {

      tjjfpz(index,unit){
        let obj = JSON.parse(JSON.stringify(this.jfpzlist[index]))
        if(unit){
          obj.unit = unit
        }

        obj['id'] = 0;
        this.jfpzlist.splice(index+1,0,obj);
      },
			__init(){
				this.lists = this.$route.params.data;
				this.axios.get('/admin/khjfpz/' + this.lists.id, {
						token: true
					})
					.then(res => {
						let data = res.data.data
						let jfpzlist = data.filter(item=>{
							if(item.skus == 0){
                if(item.type === 7){
                  if (!item["extend_params"]) {
                    item["extend_params"] = {
                      start_time:"00:00",
                      end_time:"23:00"
                    };
                  }else{
                    item["extend_params"] = JSON.parse(item["extend_params"])
                  }
                  item.unit = 5
                }else{
                  item["extend_params"] = null
                }
								return item
							}
						})
            this.jfpzlist = jfpzlist.sort((a,b)=>a.type-b.type)

						let jfpzlista = data.filter(item=>{
							if(item.skus == 1){
                if(item.type === 7){
                  if (!item["extend_params"]) {
                    item["extend_params"] = {
                      start_time:"00:00",
                      end_time:"23:00"
                    };
                  }else{
                    item["extend_params"] = JSON.parse(item["extend_params"])
                  }
                  item.unit = 5
                }else{
                  item["extend_params"] = null
                }
                return item
							}
						})
            this.jfpzlista = jfpzlista.sort((a,b)=>a.type-b.type)



          })
			},
			kzgg(){
				this.axios.get('/admin/khjfpz/save/' + this.lists.id, {
						token: true
					})
					.then(res => {
						this.__init()
					})
			},
			submit() {
				this.layout.showLoading();
				const currentDate = new Date();
				const year = currentDate.getFullYear();
				const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
				const day = ('0' + currentDate.getDate()).slice(-2);
				const hours = ('0' + currentDate.getHours()).slice(-2);
				const minutes = ('0' + currentDate.getMinutes()).slice(-2);
				const seconds = ('0' + currentDate.getSeconds()).slice(-2);
        let jfpzlist = this.jfpzlist.map((item,index)=>{
          if (item.type ===7 && item.extend_params){
            item.extend_params = JSON.stringify(item.extend_params)
          }

          return item
        })

        let jfpzlista = this.jfpzlista.map((item,index)=>{
          if (item.type ===7 && item.extend_params){
            item.extend_params = JSON.stringify(item.extend_params)
          }
          return item
        })

				let data = {
					id:this.lists.id,
					jfpz_czr:this.user.id,
					jfpz_czsj:`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
					jfpzlist:jfpzlist,
					jfpzlista:jfpzlista
				}

				this.axios.post('/admin/khxx/jfpz/' + this.lists.id, data, {
						token: true
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: '修改成功'
						});
						this.$router.push({
							name: 'khgl_khgl_khxx'
						});
						this.layout.hideLoading();
					})
					.catch(err => {
						this.layout.hideLoading();
					});
			}
		}
	};
</script>

<style>
	.goods_create .el-form-item {
		margin-bottom: 15px;
	}

	.el-form-item__label {
		width: 84px !important;
	}

	.pt-a {
		padding-top: 20px;
	}

	.a-center {
		align-items: center;
	}
</style>
